import _ from 'lodash';

export default [
  '$location',
  function UrlHashParams ($location) {
    let get = function GetHashParams () {
      let pairs = $location.hash().split('&');
      let paramObj = {};

      _.forEach(pairs, (pair) => {
        pair = pair.split('=');
        if (!pair[0] || !pair[1]) return;
        paramObj[pair[0]] = pair[1];
      });

      return paramObj;
    };

    let set = function SetHashParam (name, value) {
      let pairs = [];
      let params = get();

      if (value === null || typeof value === 'undefined') {
        delete params[name];
      }
      else params[name] = value;

      _.forEach(Object.keys(params), (key) => {
        pairs.push(`${key}=${params[key]}`);
      });

      $location.hash(pairs.join('&'));
      $location.replace();
    }

    return {
      get: get,
      set: set
    };
  }
];



// WEBPACK FOOTER //
// ./source/client/data-providers/url-hash-params.js